<script>
export default {
    name: "IconCustom",
    props: {
        icon: {
            type: String,
            default: "",
        },
        useBadge: {
            type: Boolean,
            default: false,
        },
        classes: {
            type: String,
            default: "",
        },
        styles: {
            type: String,
            default: "",
        },
    },
    setup(props) {
        let svgHTML = "";
        const badgeSpan = `<span class="icon-custom--badge bg-danger h-1 w-1 absolute rounded-full"></span>`;
        try {
            if (props.useBadge) svgHTML += badgeSpan;
            svgHTML +=
                require(`!html-loader!../../assets/icons/icon-${props.icon}.svg`).default;
        } catch (e) {
            console.warn(
                `Unable to load "icon-${props.icon}.svg" icon. Verify it exists in the icons directory.`,
                e
            );
        }

        return {
            svgHTML,
        };
    },
};
</script>

<template>
    <span
        :class="['icon-custom', `icon-custom-${icon}`, classes]"
        :style="styles"
        v-html="svgHTML"
    ></span>
</template>

<style>
.icon-custom {
    display: inline-block;
}
</style>
